const palette = {
  white: ['#ffffff'],
  black: ['#000000'],
  gray: ['#666666', '#E6E6E6', '#CCCCCC', '#F4F4F4'],
  blue: ['#25255A', '#80D6C5', '#5B9D65'],
  pink: ['#EDB9D9'],
  red: ['#d16a58'],
  green: ['#58D158', '#80D6C5', '#A3B18A', '#588157'],
  modernGreen: ['#DAD7CD26'],
}

const fonts = {
  aeonikPro: `"Fredoka", -system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`,
  fredoka: `"Fredoka", -system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`,
}

const fontsWeight = {
  light: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
}

const breakpoints = {
  sm: '43.75rem',
}

const breakpointsInPixel = {
  sm: 700,
}

const media = {
  smDown: `@media (max-width: ${breakpoints.sm})`,
  smUp: `@media (min-width: ${breakpoints.sm})`,
}

const container = {
  width: '94%',
  sizes: {
    default: '75rem', // 1200px
    small: '61.25rem', // 980px
  },
}

const transition = {
  base: 'all 0.2s ease-in',
}

const paragraphSizes = {
  extraLarge: '3rem',
  large: '1.5rem',
  normal: '1rem',
}

const headingSizes = {
  extraLarge: '4rem',
  large: '3rem',
  medium: '2rem',
  normal: '1.5rem',
  small: '0.875rem',
}

const borderRadius = {
  none: 'none',
  normal: '4px',
}

const opacity = {
  default: 1,
  base: 0.2,
}

const gap = {
  extraLarge: '2rem',
  large: '1.75rem',
  normal: '1rem',
  small: '0.5rem',
  none: '0',
}

export default {
  palette,
  fonts,
  fontsWeight,
  breakpoints,
  breakpointsInPixel,
  media,
  container,
  transition,
  paragraphSizes,
  headingSizes,
  borderRadius,
  opacity,
  gap,
}
